export default __webpack_public_path__ + "static/media/woman-sitting.f47af586.jpg";